import { StyledTableCell as TableCell } from '../components';

const extractValue = (row, col) => {
  if (typeof col?.valueGetter === 'function') {
    const params = {
      data: row,
      node: { data: row },
      colDef: col
    };
    return col.valueGetter(params);
  }
  return row[col.field];
};

const formatValue = (value, row, col) => {
  if (typeof col?.valueFormatter === 'function' && value !== undefined) {
    const params = {
      value,
      data: row,
      node: { data: row },
      colDef: col
    };
    return col.valueFormatter(params);
  }
  return value;
};

const createCellParams = ({ value, valueFormatted, row, col }) => ({
  value,
  valueFormatted,
  data: row,
  node: { data: row },
  colDef: col,
  column: col,
  api: null,
  columnApi: null,
  context: null
});

const renderCell = (row, col) => {
  const value = extractValue(row, col);
  const valueFormatted = formatValue(value, row, col);
  const params = createCellParams({ value, valueFormatted, row, col });
  const cellStyle = { width: col.printColWidth || 'auto' };

  if (col.cellRenderer) {
    if (typeof col.cellRenderer === 'function') {
      try {
        const result = col.cellRenderer(params);
        if (result !== undefined && result !== null) {
          return (
            <TableCell key={col.field} style={cellStyle}>
              {result}
            </TableCell>
          );
        }
      } catch (error) {
        //TODO: Improve this fallback logic later
        // If the cellRenderer is a class component (wrapped with HOC like withStyles), render it as JSX element
        const CellRenderer = col.cellRenderer;
        return (
          <TableCell key={col.field} style={cellStyle}>
            <CellRenderer {...params} />
          </TableCell>
        );
      }
    } else {
      // If cellRenderer is already a component reference
      const CellRendererComponent = col.cellRenderer;
      return (
        <TableCell key={col.field} style={cellStyle}>
          <CellRendererComponent {...params} />
        </TableCell>
      );
    }
  }

  return (
    <TableCell key={col.field} style={cellStyle}>
      {valueFormatted}
    </TableCell>
  );
};

export {
  extractValue,
  formatValue,
  createCellParams,
  renderCell
}; 